import { FC, useState } from "react";
import { BrgButton, ButtonVariant, FlexBox } from "@brg/ui";
import { useModal } from "core";
import { useTranslation } from "react-i18next";
import { ConfirmContent, ConfirmDescription, ConfirmTitle, ConfirmWrapper } from "./styles";

export type DeleteTeamGroupConfirmMode = "groupOnly" | "groupAndMembers";

export interface DeleteTeamGroupModalProps {
    onConfirm: (mode: DeleteTeamGroupConfirmMode) => Promise<void>;
}

export const DeleteTeamGroupModal: FC<DeleteTeamGroupModalProps> = ({ onConfirm }) => {
    const modal = useModal();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = (mode: DeleteTeamGroupConfirmMode) => {
        setIsLoading(true);
        onConfirm(mode)
            .then(() => modal.hide())
            .finally(() => setIsLoading(false));
    };

    return (
        <ConfirmWrapper>
            <ConfirmContent direction="column">
                <ConfirmTitle>{t("teams.adminPage.modal.deleteGroup.title")}</ConfirmTitle>
                <ConfirmDescription>{t("teams.adminPage.modal.deleteGroup.text")}</ConfirmDescription>
                <FlexBox
                    gy={12}
                    direction="column"
                    directionMobile="column"
                    width="100%"
                    widthMobile="100%"
                    style={{ marginTop: 8 }}
                >
                    <BrgButton
                        fullWidth
                        variant={ButtonVariant.Hollow}
                        onClick={() => modal.hide()}
                        disabled={isLoading}
                    >
                        {t("teams.adminPage.modal.deleteGroup.cancel")}
                    </BrgButton>
                    <BrgButton
                        fullWidth
                        variant={ButtonVariant.Hollow}
                        onClick={() => handleConfirm("groupOnly")}
                        disabled={isLoading}
                    >
                        {t("teams.adminPage.modal.deleteGroup.deleteGroupOnly")}
                    </BrgButton>
                    <BrgButton
                        fullWidth
                        variant={ButtonVariant.Filled}
                        onClick={() => handleConfirm("groupAndMembers")}
                        disabled={isLoading}
                    >
                        {t("teams.adminPage.modal.deleteGroup.deleteGroupAndMembers")}
                    </BrgButton>
                </FlexBox>
            </ConfirmContent>
        </ConfirmWrapper>
    );
};
import { FC, useState } from "react";
import { BrgButton, ButtonVariant, FlexBox } from "@brg/ui";
import { useModal } from "core";
import { useTranslation } from "react-i18next";
import { ConfirmContent, ConfirmDescription, ConfirmTitle, ConfirmWrapper } from "./styles";

export type DeleteTeamGroupConfirmMode = "groupOnly" | "groupAndMembers";

export interface DeleteTeamGroupModalProps {
    onConfirm: (mode: DeleteTeamGroupConfirmMode) => Promise<void>;
}

export const DeleteTeamGroupModal: FC<DeleteTeamGroupModalProps> = ({ onConfirm }) => {
    const modal = useModal();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = (mode: DeleteTeamGroupConfirmMode) => {
        setIsLoading(true);
        onConfirm(mode)
            .then(() => modal.hide())
            .finally(() => setIsLoading(false));
    };

    return (
        <ConfirmWrapper>
            <ConfirmContent direction="column">
                <ConfirmTitle>{t("teams.adminPage.modal.deleteGroup.title")}</ConfirmTitle>
                <ConfirmDescription>{t("teams.adminPage.modal.deleteGroup.text")}</ConfirmDescription>
                <FlexBox
                    gy={12}
                    direction="column"
                    directionMobile="column"
                    width="100%"
                    widthMobile="100%"
                    style={{ marginTop: 8 }}
                >
                    <BrgButton
                        fullWidth
                        variant={ButtonVariant.Hollow}
                        onClick={() => modal.hide()}
                        disabled={isLoading}
                    >
                        {t("teams.adminPage.modal.deleteGroup.cancel")}
                    </BrgButton>
                    <BrgButton
                        fullWidth
                        variant={ButtonVariant.Hollow}
                        onClick={() => handleConfirm("groupOnly")}
                        disabled={isLoading}
                    >
                        {t("teams.adminPage.modal.deleteGroup.deleteGroupOnly")}
                    </BrgButton>
                    <BrgButton
                        fullWidth
                        variant={ButtonVariant.Filled}
                        onClick={() => handleConfirm("groupAndMembers")}
                        disabled={isLoading}
                    >
                        {t("teams.adminPage.modal.deleteGroup.deleteGroupAndMembers")}
                    </BrgButton>
                </FlexBox>
            </ConfirmContent>
        </ConfirmWrapper>
    );
};
